import {
  MessageBlockRole,
  WiseOwlActionType,
  WiseOwlBlock,
  WiseOwlBlockDisplayType,
  WiseOwlBlockType,
  WiseOwlEventName,
} from "../types";

const mockPromptSuggestionGroupBlock: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.PromptSuggestionGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      categories: [
        { name: "SMS", suggestions: ["How do I ...?", "How do I ...?"] },
        { name: "Email", suggestions: ["How do I ...?", "How do I ...?"] },
      ],
    },
  },
];

const mockToolCallBlocks: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.ToolCall,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      name: "queryKnowledgeBase",
      input: "",
      output: "",
      formattedOutput: "",
    },
  },
  {
    type: WiseOwlBlockType.ToolCall,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      name: "getTwilioStatus",
      input: "",
      output: "",
      formattedOutput: "",
    },
  },
];

const mockMessageBlocks: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.Message,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      id: "9328739285",
      role: MessageBlockRole.User,
      message: "hello world!",
      isComplete: true,
      delta: null,
    },
  },
  {
    type: WiseOwlBlockType.Message,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      id: "79824789214789",
      role: MessageBlockRole.Assistant,
      message: `# Getting started with SMS notification
      
In this guide you will learn the fundamentals to build your first SMS notification app.

This guide covers:

- Getting a free trial number from Twilio
- Sending your first SMS
- A step-by-step tutorial on sending SMS notifications
- Best practices on scaling

### Getting a free trial number from Twilio

To send or receive SMS, you will need a phone number from Twilio. On your trial account, you can get one free USA or Canada phone number.

### Sending your first SMS

Next, copy and execute the following code in your command line/command prompt/terminal to send an SMS to yourself. You can expect to receive your SMS within 3 minutes. On a trial account, if you are sending an SMS to someone else, add their number to the verified caller ID first.

##### PC - Powershell (Older than Windows 10 version 1803)

Install Powershell if needed, and then open the Windows PowerShell.

\`\`\`bash
# Twilio account info and phone numbers.
$sid = "ACCOUNT_SID"
$token = "AUTH_TOKEN"
$phone_number = "PHONE_NUMBER"
$verified_number = "VERIFIED_NUMBER",

# Twilio API endpoint and POST params
$url = "https://api.twilio.com/2010-04-01/Accounts/$sid/Messages.json"
$params = @{ To = $verified_number ; From = $phone_number ; Body = "Hello from Twilio" }

# Create a credential object for HTTP basic auth
$p = $token | ConvertTo-SecureString -asPlainText -Force
$credential = New-Object System.Management.Automation.PSCredential($sid, $p)

# Make API request, selecting JSON properties from response
Invoke-WebRequest $url -Method Post -Credential $credential -Body $params -UseBasicParsing | ConvertFrom-Json | Select sid, body
\`\`\`
      `,
      isComplete: true,
      delta: null,
    },
  },
];

const mockLinkGroupBlock: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.LinkGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      links: [
        {
          title: "article 1",
          url: "https://google.com",
          preview: "This article contains",
        },
        {
          title: "article 2 - My really super long article",
          url: "https://google.com",
          preview:
            "My really super long description, oh wow there is just so much content to see here!",
        },
        {
          title: "article 3",
          url: "https://google.com",
          preview: "This article contains",
        },
        {
          title: "article 4",
          url: "https://google.com",
          preview: "This article contains",
        },
        {
          title: "article 5",
          url: "https://google.com",
          preview: "This article contains",
        },
      ],
    },
  },
];

const mockButtonGroupBlock: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.ButtonGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      buttons: [
        {
          text: "Submit a Ticket",
          action: {
            type: WiseOwlActionType.Redirect,
            values: {
              redirectUrl: "/submit",
            },
          },
        },
        {
          text: "Request a Callback",
          action: {
            type: WiseOwlActionType.Event,
            values: {
              name: WiseOwlEventName.SubmitTicket,
              metadata: {},
            },
          },
        },
        {
          text: "Live Chat",
          action: {
            type: WiseOwlActionType.Event,
            values: {
              name: WiseOwlEventName.SubmitTicket,
              metadata: {},
            },
          },
        },
      ],
    },
  },
];

const mockBlocks: WiseOwlBlock[] = [
  ...mockPromptSuggestionGroupBlock,
  ...mockToolCallBlocks,
  ...mockMessageBlocks,
  ...mockLinkGroupBlock,
  ...mockButtonGroupBlock,
];

export {
  mockPromptSuggestionGroupBlock,
  mockToolCallBlocks,
  mockMessageBlocks,
  mockLinkGroupBlock,
  mockButtonGroupBlock,
  mockBlocks,
};
